import _escapeRegExp from 'lodash/escapeRegExp';

export const searchRows = (search, { rows = [], columnIds = [] } = {}) => {
  if (!search || !columnIds.length || !rows.length) {
    return rows;
  }

  const searchQueryRegExp = new RegExp(_escapeRegExp(search.trim()), 'i');
  return rows.filter(row => {
    const columnsToSearchAgainst = columnIds.map(id => row[id]);
    return columnsToSearchAgainst.some(testString => searchQueryRegExp.test(testString));
  });
};
